export default __webpack_public_path__ + "static/media/icon-btn-up.13730dce.svg";